import { render, staticRenderFns } from "./DmsUserPassword.vue?vue&type=template&id=98e0b542"
import script from "./DmsUserPassword.vue?vue&type=script&lang=js"
export * from "./DmsUserPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports